// @ts-nocheck

export enum TaskDefinitionParameterDirections {
    Input_Output = "Input_Output",
    Input = "Input",
    Output = "Output"
}

export enum SupportedTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum StatusesOutcome {
    NoOutcome = "NoOutcome",
    Success = "Success",
    Failure = "Failure",
    Skip = "Skip"
}

export enum SupportedTypes2 {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum StatusesOutcome2 {
    NoOutcome = "NoOutcome",
    Success = "Success",
    Failure = "Failure",
    Skip = "Skip"
}

export enum LinkType {
    Never = "Never",
    IfAvailable = "IfAvailable",
    Always = "Always"
}

export enum MigrationLogLevel {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum TaskDefinitionParameterDirections2 {
    Input_Output = "Input_Output",
    Input = "Input",
    Output = "Output"
}

export enum PrimitiveTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan"
}

export enum ApplicationLogLevelType {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum AutomationDataTypeEnum {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum SegregationTagStatus {
    Available = "Available",
    Locked = "Locked"
}

export enum TimerModeEnum {
    OneShot = "OneShot",
    Periodic = "Periodic"
}

export enum TimerTypeEnum {
    Delay = "Delay",
    SpecificTime = "SpecificTime"
}

export interface LogMessageCatalog {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Owner` |
     * | Type | `Edm.String` |
     */
    Owner: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MessageId` |
     * | Type | `Edm.Int32` |
     */
    MessageId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.ApplicationLogLevelType` |
     */
    Level: ApplicationLogLevelType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogParameters` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogParameters)` |
     */
    LogMessageCatalogParameters?: Array<LogMessageCatalogParameters>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogLanguages` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogLanguages)` |
     */
    LogMessageCatalogLanguages?: Array<LogMessageCatalogLanguages>;
}

export type LogMessageCatalogId = string | {Id: string};

export interface LogMessageCatalogParameters {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterKey` |
     * | Type | `Edm.String` |
     */
    ParameterKey: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Edm.String` |
     */
    ParameterType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogParametersId = string | {Id: string};

export interface LogMessageCatalogLanguages {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogLanguagesId = string | {Id: string};

export interface File {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PayloadSize` |
     * | Type | `Edm.Int64` |
     */
    PayloadSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedBy` |
     * | Type | `Edm.String` |
     */
    CreatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedBy` |
     * | Type | `Edm.String` |
     */
    LastUpdatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder_Id` |
     * | Type | `Edm.Guid` |
     */
    Folder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    Folder?: Folder | null;
}

export type FileId = string | {Id: string};

export interface Folder {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentFolder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    ParentFolder?: Folder | null;
}

export type FolderId = string | {Id: string};

export interface SegregationTag {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagStatus` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.SegregationTagStatus` |
     */
    TagStatus: SegregationTagStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLogRelevant` |
     * | Type | `Edm.Boolean` |
     */
    IsLogRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
}

export type SegregationTagId = string | {Id: string};

export interface NumberingPattern {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityTypeNId` |
     * | Type | `Edm.String` |
     */
    EntityTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationProperty` |
     * | Type | `Edm.String` |
     */
    DestinationProperty: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.NumberingPatternFacet)` |
     */
    Facets?: Array<NumberingPatternFacet>;
}

export type NumberingPatternId = string | {Id: string};

export interface Equipment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCalendarNId` |
     * | Type | `Edm.String` |
     */
    WorkCalendarNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.EquipmentFacet)` |
     */
    Facets?: Array<EquipmentFacet>;
}

export type EquipmentId = string | {Id: string};

export interface TaskContextUserField {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContext` |
     */
    TaskContext?: TaskContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextUserFieldFacet)` |
     */
    Facets?: Array<TaskContextUserFieldFacet>;
}

export type TaskContextUserFieldId = string | {Id: string};

export interface TaskContext {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntityType` |
     * | Type | `Edm.String` |
     */
    ContextEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextDefinitionNId` |
     * | Type | `Edm.String` |
     */
    ContextDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextUserField)` |
     */
    UserFields?: Array<TaskContextUserField>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextFacet)` |
     */
    Facets?: Array<TaskContextFacet>;
}

export type TaskContextId = string | {Id: string};

export interface TaskContextDefinitionUserField {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinition` |
     */
    TaskContextDefinition?: TaskContextDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserFieldFacet)` |
     */
    Facets?: Array<TaskContextDefinitionUserFieldFacet>;
}

export type TaskContextDefinitionUserFieldId = string | {Id: string};

export interface TaskContextDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntityType` |
     * | Type | `Edm.String` |
     */
    ContextEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserField)` |
     */
    UserFields?: Array<TaskContextDefinitionUserField>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinition)` |
     */
    TaskDefinitions?: Array<TaskDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinitionFacet)` |
     */
    Facets?: Array<TaskContextDefinitionFacet>;
}

export type TaskContextDefinitionId = string | {Id: string};

export interface UoMDimension {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMs` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoM)` |
     */
    UoMs?: Array<UoM>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoMDimensionFacet)` |
     */
    Facets?: Array<UoMDimensionFacet>;
}

export type UoMDimensionId = string | {Id: string};

export interface UoM {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMDimension_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMBase_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMBase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoMDimension` |
     */
    UoMDimension?: UoMDimension | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMBase` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoM` |
     */
    UoMBase?: UoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMsMultipleOrSubmultiple` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoM)` |
     */
    UoMsMultipleOrSubmultiple?: Array<UoM>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoMFacet)` |
     */
    Facets?: Array<UoMFacet>;
}

export type UoMId = string | {Id: string};

export interface WorkflowGateway {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueCount` |
     * | Type | `Edm.Int32` |
     */
    ContinueCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockCount` |
     * | Type | `Edm.Int32` |
     */
    BlockCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SiblingCount` |
     * | Type | `Edm.Int32` |
     */
    SiblingCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.WorkflowGatewayFacet)` |
     */
    Facets?: Array<WorkflowGatewayFacet>;
}

export type WorkflowGatewayId = string | {Id: string};

export interface TaskParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.ReadingModel.TaskDefinitionParameterDirections` |
     */
    Direction: TaskDefinitionParameterDirections | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskParameterFacet)` |
     */
    Facets?: Array<TaskParameterFacet>;
}

export type TaskParameterId = string | {Id: string};

export interface Task {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCount` |
     * | Type | `Edm.Int32` |
     */
    ErrorCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSkippable` |
     * | Type | `Edm.Boolean` |
     */
    IsSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Siemens.SimaticIT.OperationalData.TSK_OP.OPModel.Types.ReadingModel.TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types` |
     * | Nullable | `false` |
     */
    TaskFlow: TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Contexts` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContext)` |
     */
    Contexts?: Array<TaskContext>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskParameters` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskParameter)` |
     */
    TaskParameters?: Array<TaskParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskFacet)` |
     */
    Facets?: Array<TaskFacet>;
}

export type TaskId = string | {Id: string};

export interface TaskType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionUI` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskEntityType` |
     * | Type | `Edm.String` |
     */
    TaskEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskTypeFacet)` |
     */
    Facets?: Array<TaskTypeFacet>;
}

export type TaskTypeId = string | {Id: string};

export interface TaskDefinitionParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.ReadingModel.TaskDefinitionParameterDirections` |
     */
    Direction: TaskDefinitionParameterDirections | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinition` |
     */
    TaskDefinition?: TaskDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinitionParameterFacet)` |
     */
    Facets?: Array<TaskDefinitionParameterFacet>;
}

export type TaskDefinitionParameterId = string | {Id: string};

export interface TaskDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionUI` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskEntityType` |
     * | Type | `Edm.String` |
     */
    TaskEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionParameters` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinitionParameter)` |
     */
    TaskDefinitionParameters?: Array<TaskDefinitionParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinition)` |
     */
    TaskContextDefinitions?: Array<TaskContextDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinitionFacet)` |
     */
    Facets?: Array<TaskDefinitionFacet>;
}

export type TaskDefinitionId = string | {Id: string};

export interface StateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Statuses` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Status)` |
     */
    Statuses?: Array<Status>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.StateMachineFacet)` |
     */
    Facets?: Array<StateMachineFacet>;
}

export type StateMachineId = string | {Id: string};

export interface Status {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInitial` |
     * | Type | `Edm.Boolean` |
     */
    IsInitial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.StatusFacet)` |
     */
    Facets?: Array<StatusFacet>;
}

export type StatusId = string | {Id: string};

export interface NumberingPatternFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPattern_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.NumberingPattern` |
     */
    NumberingPattern?: NumberingPattern | null;
}

export type NumberingPatternFacetId = string | {Id: string};

export interface EquipmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
}

export type EquipmentFacetId = string | {Id: string};

export interface TaskContextUserFieldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserField_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextUserField_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserField` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextUserField` |
     */
    TaskContextUserField?: TaskContextUserField | null;
}

export type TaskContextUserFieldFacetId = string | {Id: string};

export interface TaskContextFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContext` |
     */
    TaskContext?: TaskContext | null;
}

export type TaskContextFacetId = string | {Id: string};

export interface TaskContextDefinitionUserFieldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionUserField_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinitionUserField_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionUserField` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserField` |
     */
    TaskContextDefinitionUserField?: TaskContextDefinitionUserField | null;
}

export type TaskContextDefinitionUserFieldFacetId = string | {Id: string};

export interface TaskContextDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskContextDefinition` |
     */
    TaskContextDefinition?: TaskContextDefinition | null;
}

export type TaskContextDefinitionFacetId = string | {Id: string};

export interface UoMDimensionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMDimension_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoMDimension` |
     */
    UoMDimension?: UoMDimension | null;
}

export type UoMDimensionFacetId = string | {Id: string};

export interface UoMFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM_Id` |
     * | Type | `Edm.Guid` |
     */
    UoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.UoM` |
     */
    UoM?: UoM | null;
}

export type UoMFacetId = string | {Id: string};

export interface WorkflowGatewayFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkflowGateway_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkflowGateway_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkflowGateway` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.WorkflowGateway` |
     */
    WorkflowGateway?: WorkflowGateway | null;
}

export type WorkflowGatewayFacetId = string | {Id: string};

export interface TaskParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskParameter` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskParameter` |
     */
    TaskParameter?: TaskParameter | null;
}

export type TaskParameterFacetId = string | {Id: string};

export interface TaskFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
}

export type TaskFacetId = string | {Id: string};

export interface TaskTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskType_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskType` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskType` |
     */
    TaskType?: TaskType | null;
}

export type TaskTypeFacetId = string | {Id: string};

export interface TaskDefinitionParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinitionParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinitionParameter` |
     */
    TaskDefinitionParameter?: TaskDefinitionParameter | null;
}

export type TaskDefinitionParameterFacetId = string | {Id: string};

export interface TaskDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.TaskDefinition` |
     */
    TaskDefinition?: TaskDefinition | null;
}

export type TaskDefinitionFacetId = string | {Id: string};

export interface StateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
}

export type StateMachineFacetId = string | {Id: string};

export interface StatusFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status_Id` |
     * | Type | `Edm.Guid` |
     */
    Status_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.DataModel.ReadingModel.Status` |
     */
    Status?: Status | null;
}

export type StatusFacetId = string | {Id: string};

export interface ExecutionError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ErrorCode: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PrecheckExecution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
}

export interface SitUafExecutionDetail {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrecheckDetails` |
     * | Type | `Collection(Siemens.SimaticIT.Unified.Common.PrecheckExecution)` |
     * | Nullable | `false` |
     */
    PrecheckDetails: Array<PrecheckExecution>;
}

export interface CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Succeeded` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Succeeded: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SitUafExecutionDetail` |
     * | Type | `Siemens.SimaticIT.Unified.Common.SitUafExecutionDetail` |
     */
    SitUafExecutionDetail: SitUafExecutionDetail | null;
}

export interface FunctionResponse extends CommandResponse {
}

export interface PreCheckResponse extends CommandResponse {
}

export interface AdditionalArgumentsDefinition {
}

export interface ServiceLayerUnityError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `commandcallstack` |
     * | Type | `Collection(Edm.String)` |
     */
    commandcallstack: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `stacktrace` |
     * | Type | `Edm.String` |
     */
    stacktrace: string | null;
}

export interface ServiceLayerErrorObject {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `code` |
     * | Type | `Edm.String` |
     */
    code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `message` |
     * | Type | `Edm.String` |
     */
    message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `innererror` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerUnityError` |
     */
    innererror: ServiceLayerUnityError | null;
}

export interface ServiceLayerError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `error` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerErrorObject` |
     */
    error: ServiceLayerErrorObject | null;
}

export interface CreateTaskDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinitionId: string | null;
}

export interface CreateTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface UpdateTaskDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
}

export interface UpdateTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.TaskDefinitionParameterParameterType)` |
     * | Nullable | `false` |
     */
    Parameters: Array<TaskDefinitionParameterParameterType>;
}

export interface DeleteTaskDefinitionResponse extends CommandResponse {
}

export interface DeleteTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateTaskDefinitionParameterResponse extends CommandResponse {
}

export interface UpdateTaskDefinitionParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.TaskDefinitionParameterDirections` |
     */
    Direction: TaskDefinitionParameterDirections | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface DeleteTaskDefinitionParameterResponse extends CommandResponse {
}

export interface DeleteTaskDefinitionParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface LockTaskDefinitionResponse extends CommandResponse {
}

export interface LockTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlockTaskDefinitionResponse extends CommandResponse {
}

export interface UnlockTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetTaskDefinitionRevisionCurrentResponse extends CommandResponse {
}

export interface SetTaskDefinitionRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnsetTaskDefinitionRevisionCurrentResponse extends CommandResponse {
}

export interface UnsetTaskDefinitionRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CopyTaskDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinitionId: string | null;
}

export interface CopyTaskDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface CreateNewTaskDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinitionId: string | null;
}

export interface CreateNewTaskDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface AssociateTaskContextDefinitionsWithTaskDefinitionResponse extends CommandResponse {
}

export interface AssociateTaskContextDefinitionsWithTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TaskDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TaskContextDefinitionIds: Array<string>;
}

export interface DisassociateTaskContextDefinitionsFromTaskDefinitionResponse extends CommandResponse {
}

export interface DisassociateTaskContextDefinitionsFromTaskDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TaskDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TaskContextDefinitionIds: Array<string>;
}

export interface CreateTaskContextDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinitionId: string | null;
}

export interface CreateTaskContextDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateTaskContextDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserFieldIds: Array<string>;
}

export interface UpdateTaskContextDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.UserFieldParameterType)` |
     */
    UserFields: Array<UserFieldParameterType>;
}

export interface DeleteTaskContextDefinitionResponse extends CommandResponse {
}

export interface DeleteTaskContextDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateTaskContextDefinitionUserFieldResponse extends CommandResponse {
}

export interface UpdateTaskContextDefinitionUserField {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
}

export interface DeleteTaskContextDefinitionUserFieldResponse extends CommandResponse {
}

export interface DeleteTaskContextDefinitionUserField {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateTaskResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
}

export interface CreateTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSkippable` |
     * | Type | `Edm.Boolean` |
     */
    IsSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Siemens.SimaticIT.OperationalData.TSK_OP.OPModel.Types.TaskFlowParameterType` |
     */
    TaskFlow: TaskFlowParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ParameterValueParameterType)` |
     */
    ParameterValues: Array<ParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextUserFieldValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ContainerUserFieldParameterType)` |
     */
    ContextUserFieldValues: Array<ContainerUserFieldParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface UpdateTaskResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
}

export interface UpdateTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCount` |
     * | Type | `Edm.Int32` |
     */
    ErrorCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Siemens.SimaticIT.OperationalData.TSK_OP.OPModel.Types.TaskFlowParameterType` |
     */
    TaskFlow: TaskFlowParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSkippable` |
     * | Type | `Edm.Boolean` |
     */
    IsSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.TaskDefinitionParameterParameterType)` |
     */
    Parameters: Array<TaskDefinitionParameterParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ParameterValueParameterType)` |
     */
    ParameterValues: Array<ParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface DeleteTaskResponse extends CommandResponse {
}

export interface DeleteTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateTaskParameterResponse extends CommandResponse {
}

export interface UpdateTaskParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface SetTaskStatusResponse extends CommandResponse {
}

export interface SetTaskStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Verb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface ForceTaskStatusResponse extends CommandResponse {
}

export interface ForceTaskStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserName` |
     * | Type | `Edm.String` |
     */
    UserName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface ActivateTaskResponse extends CommandResponse {
}

export interface ActivateTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface SuspendTaskResponse extends CommandResponse {
}

export interface SuspendTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface StartTaskResponse extends CommandResponse {
}

export interface StartTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface PauseTaskResponse extends CommandResponse {
}

export interface PauseTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface ResumeTaskResponse extends CommandResponse {
}

export interface ResumeTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface RecoverTaskResponse extends CommandResponse {
}

export interface RecoverTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface FailTaskResponse extends CommandResponse {
}

export interface FailTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface CompleteTaskResponse extends CommandResponse {
}

export interface CompleteTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface AbortTaskResponse extends CommandResponse {
}

export interface AbortTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface CancelTaskResponse extends CommandResponse {
}

export interface CancelTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface SkipTaskResponse extends CommandResponse {
}

export interface SkipTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface FreezeTaskResponse extends CommandResponse {
}

export interface FreezeTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnfreezeTaskResponse extends CommandResponse {
}

export interface UnfreezeTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetErrorCountResponse extends CommandResponse {
}

export interface SetErrorCount {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCount` |
     * | Type | `Edm.Int32` |
     */
    ErrorCount: number | null;
}

export interface ChangeTaskStatusOnActionResponse extends CommandResponse {
}

export interface ChangeTaskStatusOnAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Verb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface RepeatTaskResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
}

export interface RepeatTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface ActivateSequenceStepResponse extends CommandResponse {
}

export interface ActivateSequenceStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskFlow: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface CheckSequenceStepCompletedResponse extends CommandResponse {
}

export interface CheckSequenceStepCompleted {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionToken` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SectionToken: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Block` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Block: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SiblingCount` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SiblingCount: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskFlow: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockAndContinue` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    BlockAndContinue: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLastStep` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsLastStep: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface RemoveTaskFromTaskFlowResponse extends CommandResponse {
}

export interface RemoveTaskFromTaskFlow {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface TaskDefinitionParameterParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsReadOnly: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.TaskDefinitionParameterDirections` |
     * | Nullable | `false` |
     */
    Direction: TaskDefinitionParameterDirections;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    ParameterType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface UserFieldParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    UserFieldType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface ParameterValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface UserFieldValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserFieldNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
}

export interface ContainerUserFieldParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.UserFieldValueParameterType)` |
     */
    UserFieldValues: Array<UserFieldValueParameterType>;
}

export interface StatusTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StateMachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusesOutcome` |
     * | Nullable | `false` |
     */
    Outcome: StatusesOutcome;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
}

export interface TaskFlowParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxIterations` |
     * | Type | `Edm.Int32` |
     */
    MaxIterations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskFlow: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnSuccess` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnSuccess: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnFailure` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnFailure: boolean | null;
}

export interface DeleteTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedTaskIds: Array<string>;
}

export interface DeleteTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface ActivateTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivatedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActivatedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotActivatedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotActivatedTaskIds: Array<string>;
}

export interface ActivateTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface AbortTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AbortedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AbortedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotAbortedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotAbortedTaskIds: Array<string>;
}

export interface AbortTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface CancelTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanceledTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    CanceledTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotCanceledTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotCanceledTaskIds: Array<string>;
}

export interface CancelTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface CompleteTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    CompletedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotCompletedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotCompletedTaskIds: Array<string>;
}

export interface CompleteTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface SkipTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkippedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkippedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotSkippedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotSkippedTaskIds: Array<string>;
}

export interface SkipTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface SuspendTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SuspendedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SuspendedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotSuspendedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotSuspendedTaskIds: Array<string>;
}

export interface SuspendTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface PauseTasksResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PausedTaskIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotPausedTaskIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotPausedTaskIds: Array<string>;
}

export interface PauseTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface DeleteTaskDefinitionsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedTaskDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedTaskDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedTaskDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedTaskDefinitionIds: Array<string>;
}

export interface DeleteTaskDefinitions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteTaskContextDefinitionsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedTaskContextDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedTaskContextDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedTaskContextDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedTaskContextDefinitionIds: Array<string>;
}

export interface DeleteTaskContextDefinitions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface GetTasksForTaskListResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCount` |
     * | Type | `Edm.Int32` |
     */
    ErrorCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSkippable` |
     * | Type | `Edm.Boolean` |
     */
    IsSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusTypeParameterType` |
     */
    Status: StatusTypeParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Siemens.SimaticIT.OperationalData.TSK_OP.OPModel.Types.TaskFlowParameterType` |
     */
    TaskFlow: TaskFlowParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRepeatable` |
     * | Type | `Edm.Boolean` |
     */
    IsRepeatable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsFrozen: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface GetTasksForTaskList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideTasksInFinalStates` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    HideTasksInFinalStates: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserFieldValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ContainerUserFieldParameterType)` |
     */
    TaskContextUserFieldValues: Array<ContainerUserFieldParameterType>;
}

export interface GetAllTasksResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.Task.Task.TSPOMModel.Types.StateMachineStatusNIdParameterType` |
     */
    Status: StateMachineStatusNIdParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Contexts` |
     * | Type | `Collection(Siemens.SimaticIT.Task.Task.TSPOMModel.Types.TaskContextParameterType)` |
     */
    Contexts: Array<TaskContextParameterType>;
}

export interface GetAllTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserFieldValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.UserFieldValueParameterType)` |
     * | Nullable | `false` |
     */
    TaskContextUserFieldValues: Array<UserFieldValueParameterType>;
}

export interface IQueryable {
}

export interface StateMachineStatusNIdParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StateMachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
}

export interface TaskContextParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.UserFieldValueParameterType)` |
     */
    UserFields: Array<UserFieldValueParameterType>;
}

export interface BaseResponse extends CommandResponse {
}

export interface TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxIterations` |
     * | Type | `Edm.Int32` |
     */
    MaxIterations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IterationGroupId` |
     * | Type | `Edm.Guid` |
     */
    IterationGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnSuccess` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnSuccess: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnFailure` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnFailure: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Edm.String` |
     */
    TaskFlow: string | null;
}

export interface QuantityType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    QuantityValue: number | null;
}

export interface StatusType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface GetTasksForTaskList2Params {
    function?: GetTasksForTaskList | null;
}

export interface GetAllTasks2Params {
    function?: GetAllTasks | null;
}

export interface CreateTaskDefinition2Params {
    command?: CreateTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTaskDefinition2Params {
    command?: UpdateTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskDefinition2Params {
    command?: DeleteTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTaskDefinitionParameter2Params {
    command?: UpdateTaskDefinitionParameter | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskDefinitionParameter2Params {
    command?: DeleteTaskDefinitionParameter | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface LockTaskDefinition2Params {
    command?: LockTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UnlockTaskDefinition2Params {
    command?: UnlockTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SetTaskDefinitionRevisionCurrent2Params {
    command?: SetTaskDefinitionRevisionCurrent | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UnsetTaskDefinitionRevisionCurrent2Params {
    command?: UnsetTaskDefinitionRevisionCurrent | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CopyTaskDefinitionRevision2Params {
    command?: CopyTaskDefinitionRevision | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CreateNewTaskDefinitionRevision2Params {
    command?: CreateNewTaskDefinitionRevision | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface AssociateTaskContextDefinitionsWithTaskDefinition2Params {
    command?: AssociateTaskContextDefinitionsWithTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DisassociateTaskContextDefinitionsFromTaskDefinition2Params {
    command?: DisassociateTaskContextDefinitionsFromTaskDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CreateTaskContextDefinition2Params {
    command?: CreateTaskContextDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTaskContextDefinition2Params {
    command?: UpdateTaskContextDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskContextDefinition2Params {
    command?: DeleteTaskContextDefinition | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTaskContextDefinitionUserField2Params {
    command?: UpdateTaskContextDefinitionUserField | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskContextDefinitionUserField2Params {
    command?: DeleteTaskContextDefinitionUserField | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CreateTask2Params {
    command?: CreateTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTask2Params {
    command?: UpdateTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTask2Params {
    command?: DeleteTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UpdateTaskParameter2Params {
    command?: UpdateTaskParameter | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SetTaskStatus2Params {
    command?: SetTaskStatus | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ForceTaskStatus2Params {
    command?: ForceTaskStatus | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ActivateTask2Params {
    command?: ActivateTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SuspendTask2Params {
    command?: SuspendTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface StartTask2Params {
    command?: StartTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface PauseTask2Params {
    command?: PauseTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ResumeTask2Params {
    command?: ResumeTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface RecoverTask2Params {
    command?: RecoverTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface FailTask2Params {
    command?: FailTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CompleteTask2Params {
    command?: CompleteTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface AbortTask2Params {
    command?: AbortTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CancelTask2Params {
    command?: CancelTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SkipTask2Params {
    command?: SkipTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface FreezeTask2Params {
    command?: FreezeTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface UnfreezeTask2Params {
    command?: UnfreezeTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SetErrorCount2Params {
    command?: SetErrorCount | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ChangeTaskStatusOnAction2Params {
    command?: ChangeTaskStatusOnAction | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface RepeatTask2Params {
    command?: RepeatTask | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ActivateSequenceStep2Params {
    command?: ActivateSequenceStep | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CheckSequenceStepCompleted2Params {
    command?: CheckSequenceStepCompleted | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface RemoveTaskFromTaskFlow2Params {
    command?: RemoveTaskFromTaskFlow | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTasks2Params {
    command?: DeleteTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface ActivateTasks2Params {
    command?: ActivateTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface AbortTasks2Params {
    command?: AbortTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CancelTasks2Params {
    command?: CancelTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface CompleteTasks2Params {
    command?: CompleteTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SkipTasks2Params {
    command?: SkipTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface SuspendTasks2Params {
    command?: SuspendTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface PauseTasks2Params {
    command?: PauseTasks | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskDefinitions2Params {
    command?: DeleteTaskDefinitions | null;
    additional?: AdditionalArgumentsDefinition | null;
}

export interface DeleteTaskContextDefinitions2Params {
    command?: DeleteTaskContextDefinitions | null;
    additional?: AdditionalArgumentsDefinition | null;
}
